import React from 'react';
import { Image } from '../../../commonTypes/image';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { RichTextOnLinkClick } from '../../RichText';
import {
  CardRichText,
  ContactCardContainer,
  JobTitle,
  LinkedInImage,
  LinkedInLink,
  LinkedInWrapper,
  Name,
  ProfileImage,
  StyledLink,
} from './styles';

export type ContactCardOnLinkClick = RichTextOnLinkClick;

export type ContactCardProps = {
  profileImage: Image;
  jobTitle: string;
  name: string;
  emailAddress?: string;
  contactDetails: string;
  phoneNumber?: string;
  openPhoneInNewTab?: boolean;
  linkedInLink?: string;
  linkedInLogo?: Image;
  onLinkClick?: ContactCardOnLinkClick;
} & ComponentProps;

const ContactCard: React.FC<ContactCardProps> = ({
  profileImage,
  jobTitle,
  name,
  emailAddress,
  contactDetails,
  phoneNumber,
  openPhoneInNewTab,
  linkedInLink,
  linkedInLogo,
  onLinkClick,
  ...props
}) => {
  const emailHref = `mailto:${emailAddress}`;
  const phoneHref = `tel:${phoneNumber}`;

  return (
    <ContactCardContainer {...componentProps(props)} tabIndex={0}>
      <ProfileImage src={profileImage.url} alt={profileImage.altText} focusable={false} />
      <JobTitle>{jobTitle}</JobTitle>
      <Name>{name}</Name>
      {emailAddress && (
        <StyledLink
          href={`mailto:${emailAddress}`}
          onClick={
            onLinkClick &&
            (() => {
              onLinkClick(emailAddress, emailHref);
            })
          }
          removeVisitedStyle>
          {emailAddress}
        </StyledLink>
      )}
      <CardRichText html={contactDetails} onLinkClick={onLinkClick}></CardRichText>
      {phoneNumber && (
        <StyledLink
          href={`tel:${phoneNumber}`}
          onClick={
            onLinkClick &&
            (() => {
              onLinkClick(phoneNumber, phoneHref);
            })
          }
          openInNewTab={openPhoneInNewTab}
          removeVisitedStyle>
          {phoneNumber}
        </StyledLink>
      )}
      {linkedInLink && (
        <LinkedInWrapper tabIndex={0}>
          {linkedInLogo && (
            <LinkedInImage
              src={linkedInLogo.url}
              alt={linkedInLogo.altText}
              focusable={false}
            />
          )}
          <LinkedInLink
            href={linkedInLink}
            onClick={
              onLinkClick &&
              (() => {
                onLinkClick(name, linkedInLink);
              })
            }
            removeVisitedStyle>
            {name}
          </LinkedInLink>
        </LinkedInWrapper>
      )}
    </ContactCardContainer>
  );
};

export default applyComponentTheme(ContactCard, 'ContactCard');
